export default __webpack_public_path__ + "longchamp.fee5505.jpeg";